import React, { FC, Fragment } from 'react'
import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  DrawerHeader,
  Heading,
  Text,
  Stack,
} from '@chakra-ui/react'

import { Empty, Loader } from 'components'

import RoleFilterTags from 'Attendances/components/RoleFilterTags'
import CustomFormRoleCardToSelect from './components/CustomFormRoleCardToSelect'
import { useCustomFormRoleSelectionDrawerManager } from '../../contexts/CustomFormRoleSelectionDrawerManager/Provider'

type Props = {
  onClose: () => void
}

const SelectRoleOnCustomForm: FC<Props> = ({ onClose }) => {
  const { loadingRoles, roles, setView, filter, setFilter } = useCustomFormRoleSelectionDrawerManager()

  return (
    <>
      <DrawerCloseButton />

      <DrawerHeader>
        <Text>Papéis disponíveis</Text>
        <Heading color="primary">Selecione um papel</Heading>
      </DrawerHeader>

      <DrawerBody overflowY="auto">
        <RoleFilterTags px={4} pb={4} roleFilter={filter} setRoleFilter={setFilter} />

        {loadingRoles ? (
          <Loader text={'Carregando papéis disponíveis'} />
        ) : (
          <Fragment>
            {roles.length > 0 ? (
              <Stack>
                {roles.map((role) => (
                  <CustomFormRoleCardToSelect key={role.id} role={role} onClose={onClose} />
                ))}
              </Stack>
            ) : (
              <Empty title={'Nenhum papel encontrado'} description="Sua busca não retornou registros" />
            )}
          </Fragment>
        )}
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={() => setView('SEARCH_ROLE')}>
          Voltar
        </Button>

        <Button onClick={onClose}>Concluir</Button>
      </DrawerFooter>
    </>
  )
}

export default SelectRoleOnCustomForm
